import React, { Component } from "react";
import Icon from "../2/Controls/Icon";
import { currenySymbol, roundUpTo2, isMobileApp } from "../../actions/Util";
import DashboardTableWidget from "../2/Controls/DashboardTableWidget";
import DashboardDyanamicChartWidget from "../2/Controls/DashboardDyanamicChartWidget";

class InventoryDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inventorySummary: {
        totalItems: 0,
        activeItems: 0,
        inactiveItems: 0,
        lowStock: 0,
        outOfStock: 0,
        expiringSoon: 0
      },
      inventoryValuationSummary: {
        totalValue: 0,
        totalQty: 0,
        totalItems: 0
      },
      mostPurchaseCategory: [],
      mostPurchaseSubCategory: [],
      mostPurchaseBrand: [],

      storeWisePurchase: [],
      quaterlyPurchase: [],
      last12MonthPurchase: [],

      mostPurchaseProduct: [],
      topVendorPurchase: [],

      topExpenseCategories: [],

      loadingMostPurchaseProduct: false,
      loadingTopVendorPurchase: false,

      loadingTopExpenseCategory: false,
      loadingStoreWisePurchase: false,
      loadingQuaterlyPurchase: false,
      loadingLast12MonthPurchase: false,

      loadingCategory: false,
      loadingSubCategory: false,
      loadingBrand: false
    };
  }





  async loadInventorySummary() {
    try {
      const result = await this.props.getInventorySummary(this.props.storeIDs);

      this.setState({
        inventorySummary: {
          totalItems: result.totalItems || 0,
          activeItems: result.activeItems || 0,
          inactiveItems: result.inactiveItems || 0,
          expiringSoon: result.expiringSoon || 0,
          outOfStock: result.outOfStockCount || 0,
          lowStock: result.lowStockCount || result.lossCount || 0
        }
      });
    } catch (err) {
      console.error("Error fetching inventory:", err);
    }
  }

  async loadMostPurchaseCategory() {
    this.setState({ loadingCategory: true });
    try {
      const result = await this.props.getMostPurchaseCategory(
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );


      this.setState({
        mostPurchaseCategory: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingCategory: false });
    }
  }


  async loadStoreWisePurchase() {
    this.setState({ loadingStoreWisePurchase: true });
    try {
      const result = await this.props.getStoreWisePurchase(
        this.props.user.user.RegistrationID,
        this.props.fromDate,
        this.props.toDate,
        this.props.storeIDs
      );


      this.setState({
        storeWisePurchase: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingStoreWisePurchase: false });
    }
  }

  async loadQuaterlyPurchase() {
    this.setState({ loadingQuaterlyPurchase: true });
    try {
      const result = await this.props.getQuaterlyPurchase(
        this.props.user.user.RegistrationID,
        this.props.storeIDs
      );


      this.setState({
        quaterlyPurchase: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingQuaterlyPurchase: false });
    }
  }


  async loadLast12MonthPurchasePurchase() {
    this.setState({ loadingLast12MonthPurchase: true });
    try {
      const result = await this.props.getLast12MonthPurchase(
        this.props.user.user.RegistrationID,
        this.props.storeIDs
      );


      this.setState({
        last12MonthPurchase: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingLast12MonthPurchase: false });
    }
  }

  async loadTopExpenseCategory() {
    this.setState({ loadingTopExpenseCategory: true });
    try {
      const result = await this.props.getTopExpenseCategories(
        this.props.user.user.RegistrationID,
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );


      this.setState({
        topExpenseCategories: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingTopExpenseCategory: false });
    }
  }

  async loadTopVendorPurchase() {
    this.setState({ loadingTopVendorPurchase: true });
    try {
      const result = await this.props.getTopVendorPurchases(
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );


      this.setState({
        topVendorPurchase: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingTopVendorPurchase: false });
    }
  }


  async loadMostPurchasedProducts() {
    this.setState({ loadingMostPurchaseProduct: true });
    try {
      const result = await this.props.getMostPurchasedProducts(
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );


      this.setState({
        mostPurchaseProduct: result.data
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingMostPurchaseProduct: false });
    }
  }

  async loadMostPurchaseSubCategory() {
    this.setState({ loadingSubCategory: true });
    try {
      const result = await this.props.getMostPurchaseSubCategory(
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );

      this.setState({
        mostPurchaseSubCategory:
          result && result.hasOwnProperty("data")
            ? result.data
            : []
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingSubCategory: false });
    }
  }

  async loadMostPurchaseBrand() {
    this.setState({ loadingBrand: true });
    try {
      const result = await this.props.getMostPurchaseBrand(
        this.props.storeIDs,
        this.props.fromDate,
        this.props.toDate
      );

      this.setState({
        mostPurchaseBrand:
          result && result.hasOwnProperty("data")
            ? result.data
            : []
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loadingBrand: false });
    }
  }



  async loadInventoryValuationSummary() {
    try {
      const result = await this.props.getInventoryValuationSummary(this.props.storeIDs);

      this.setState({
        inventoryValuationSummary: {
          totalValue: result.totalPurchase || 0,
          totalQty: result.totalQty || 0,
          totalItems: result.totalItemsCoutn || 0
        }
      });
    } catch (err) {
      console.error("Error fetching valuation:", err);
    }
  }

  async loadData() {
    await Promise.all([
      this.loadInventorySummary(),
      this.loadInventoryValuationSummary(),
      this.loadMostPurchaseBrand(),
      this.loadMostPurchaseCategory(),
      this.loadMostPurchaseSubCategory(),
      this.loadStoreWisePurchase(),
      this.loadQuaterlyPurchase(),
      this.loadLast12MonthPurchasePurchase(),
      this.loadTopExpenseCategory(),
      this.loadTopVendorPurchase(),
      this.loadMostPurchasedProducts(),
    ]);
  }
  buildStoreWiseChart() {
    const data = this.state.storeWisePurchase || [];

    return {
      labels: data.map(x => x.store),
      datasets: [
        {
          label: "Purchase",
          data: data.map(x => x.total_purchase),
          backgroundColor: "#6e2d90"
        }
      ]
    };
  }

  buildQuarterlyChart() {
    const data = this.state.quaterlyPurchase || [];

    return {
      labels: data.map(x => x.date_as_string),
      datasets: [
        {
          label: "Purchase",
          data: data.map(x => x.total_purchase),
          backgroundColor: "#42a5f5"
        }
      ]
    };
  }

  buildLast12MonthChart() {
    const data = this.state.last12MonthPurchase || [];

    return {
      labels: data.map(x => x.month_as_string),
      datasets: [
        {
          label: "Purchase",
          data: data.map(x => x.total_purchase),
          backgroundColor: "#66bb6a"
        }
      ]
    };
  }


  componentDidUpdate(prevProps) {
    console.log("this.props.storeIDs", this.props.storeIDs);
    if (prevProps.storeIDs !== this.props.storeIDs) {
      this.loadData();
    }

    if (prevProps.fromDate !== this.props.fromDate) {
      this.loadData();
    }
    if (prevProps.toDate !== this.props.toDate) {
      this.loadData();
    }
  }

  async componentDidMount() {
    await this.loadData();
  }

  // Web layout (unchanged)
  renderDesktop() {
  const { inventorySummary, inventoryValuationSummary } = this.state;

  const boxes = [
    { label: "Total Value", value: inventoryValuationSummary.totalValue, type: "currency",navigate:"/home/reports/Instock" },
    { label: "Total Items", value: inventoryValuationSummary.totalItems ,navigate:"/home/reports/Instock"},
    { label: "Total Qty", value: inventoryValuationSummary.totalQty,navigate:"/home/reports/Instock" },
    { label: "Low Stock", value: inventorySummary.lowStock, color: "red", navigate: "/home/reports/lowstockreport" },
    { label: "Out of Stock", value: inventorySummary.outOfStock, color: "orange",navigate:"/home/reports/outofstockreport" },
    { label: "Expiring Soon", value: inventorySummary.expiringSoon },
  ];

  return (
    <div style={{ gap: "10px" }}>
      <div style={{ display: "flex", gap: "10px" }}>
        {boxes.map((box, index) => (
          <div
            key={index}
            className={`info-box info-white`}
            style={{
              flex: 1,
              cursor: box.hasOwnProperty("navigate") ? "pointer" : "default"
            }}
            onClick={() => {
              if (box.hasOwnProperty("navigate")) {
                this.props.history.push(box.navigate);
              }
            }}
          >
            <div className="info-box-content">
              <div className="info-box-gray-text">{box.label}</div>

              <div
                className={!box.color ? "info-box-gray-number" : ""}
                style={
                  box.color
                    ? { color: box.color, fontSize: "24px" }
                    : {}
                }
              >
                {box.type === "currency"
                  ? `${currenySymbol()} ${roundUpTo2(box.value)}`
                  : roundUpTo2(box.value)}
              </div>
            </div>
          </div>
        ))}
      </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "10px",
          
        }}>

          <DashboardDyanamicChartWidget
            loading={this.state.loadStoreWisePurchase}
            title="Store Wise Purchase"
            chartType="bar"
            chartData={this.buildStoreWiseChart()}
            columns={[
              { label: "Store", value: "store" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Qty", value: "total_qty" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.storeWisePurchase}
          />

          {/* Quarterly */}
          <DashboardDyanamicChartWidget
            loading={this.state.loadQuaterlyPurchase}
            title="Quarterly Purchase"
            chartType="pie"
            chartData={this.buildQuarterlyChart()}
            columns={[
              { label: "Quarter", value: "date_as_string" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.quaterlyPurchase}
          />

          {/* Last 12 Months */}
          <DashboardDyanamicChartWidget
            loading={this.state.loadLast12MonthPurchasePurchase}
            title="Last 12 Months Purchase"
            chartType="bar"
            chartData={this.buildLast12MonthChart()}
            columns={[
              { label: "Month", value: "month_as_string" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.last12MonthPurchase}
          />

          <DashboardTableWidget
            title="Category"
            data={this.state.mostPurchaseCategory}
            columns={[
              { label: "Category", key: "Category" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingCategory}
          />
          <DashboardTableWidget
            title="Sub Category"
            data={this.state.mostPurchaseSubCategory || []}
            columns={[
              { label: "Sub Category", key: "SubCategory" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingSubCategory}
          />
          <DashboardTableWidget
            title="Brand"
            data={this.state.mostPurchaseBrand}
            columns={[
              { label: "Brand", key: "Brand" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingBrand}
          />

         

          <DashboardTableWidget
            title="Most Purchase Product"
            data={this.state.mostPurchaseProduct}
            columns={[
              { label: "Product", key: "Product" },
              { label: "Qty", key: "Qty" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingMostPurchaseProduct}
          />
          <DashboardTableWidget
            title="Top Vendor Purchase"
            data={this.state.topVendorPurchase}
            columns={[
              { label: "Vendor Name", key: "vendorName" },
              { label: "Qty", key: "totalQty" },
              {label:"Total Transactions",key:"totalTransactions"},
              { label: "Purchase", key: "totalPurchase", align: "right" }
            ]}
            loading={this.state.loadingTopVendorPurchase}
          />
           <DashboardTableWidget
            title="Top Expense Category"
            data={this.state.topExpenseCategories}
            columns={[
              { label: "Category", key: "ExpenseCategory" },
              { label: "Amount", key: "TotalAmount", align: "right" }
            ]}
            loading={this.state.loadingTopExpenseCategory}
          />
        </div>
      </div>
    );
  }

  // Phones: same summary cards and stacking grid as the Sales dashboard
  renderMobile() {
  const { inventorySummary, inventoryValuationSummary } = this.state;

  // Same summary cards as the Sales dashboard (info-box + colour + icon)
  const boxes = [
    { label: "Total Value", value: inventoryValuationSummary.totalValue, type: "currency", color: "blue", icon: "wallet", navigate: "/home/reports/Instock" },
    { label: "Total Items", value: inventoryValuationSummary.totalItems, color: "purple", icon: "product", navigate: "/home/reports/Instock" },
    { label: "Total Qty", value: inventoryValuationSummary.totalQty, color: "green", icon: "inventory", navigate: "/home/reports/Instock" },
    { label: "Low Stock", value: inventorySummary.lowStock, color: "yellow", icon: "notification", navigate: "/home/reports/lowstockreport" },
    { label: "Out of Stock", value: inventorySummary.outOfStock, color: "red", icon: "info", navigate: "/home/reports/outofstockreport" },
    { label: "Expiring Soon", value: inventorySummary.expiringSoon, color: "orange", icon: "appointment" },
  ];

  return (
    <div className="inventory-dashboard">
      <div className="row">
        {boxes.map((box, index) => (
          <div key={index} className="col-md-4 col-sm-6">
            <div
              className={"info-box info-" + box.color}
              role={box.navigate ? "button" : undefined}
              tabIndex={box.navigate ? 0 : undefined}
              style={{ cursor: box.navigate ? "pointer" : "default" }}
              onClick={() => {
                if (box.navigate) this.props.history.push(box.navigate);
              }}
              onKeyDown={(e) => {
                if (box.navigate && (e.key === "Enter" || e.key === " ")) this.props.history.push(box.navigate);
              }}
            >
              <div className="info-box-icon">
                <Icon type={box.icon} />
              </div>
              <div className="info-box-content">
                <div className="info-box-text">{box.label}</div>
                <div className="info-box-number">
                  {box.type === "currency"
                    ? `${currenySymbol()} ${roundUpTo2(box.value)}`
                    : roundUpTo2(box.value)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
        <div className="row inventory-dashboard-widgets">

          <div className="col-md-4">
          <DashboardDyanamicChartWidget
            loading={this.state.loadStoreWisePurchase}
            title="Store Wise Purchase"
            chartType="bar"
            chartData={this.buildStoreWiseChart()}
            columns={[
              { label: "Store", value: "store" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Qty", value: "total_qty" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.storeWisePurchase}
          />
          </div>

          {/* Quarterly */}
          <div className="col-md-4">
          <DashboardDyanamicChartWidget
            loading={this.state.loadQuaterlyPurchase}
            title="Quarterly Purchase"
            chartType="pie"
            chartData={this.buildQuarterlyChart()}
            columns={[
              { label: "Quarter", value: "date_as_string" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.quaterlyPurchase}
          />
          </div>

          {/* Last 12 Months */}
          <div className="col-md-4">
          <DashboardDyanamicChartWidget
            loading={this.state.loadLast12MonthPurchasePurchase}
            title="Last 12 Months Purchase"
            chartType="bar"
            chartData={this.buildLast12MonthChart()}
            columns={[
              { label: "Month", value: "month_as_string" },
              { label: "Purchase", value: "total_purchase" },
              { label: "Transactions", value: "total_transactions" }
            ]}
            rows={this.state.last12MonthPurchase}
          />
          </div>

          <div className="col-md-4">
          <DashboardTableWidget
            title="Category"
            data={this.state.mostPurchaseCategory}
            columns={[
              { label: "Category", key: "Category" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingCategory}
          />
          </div>
          <div className="col-md-4">
          <DashboardTableWidget
            title="Sub Category"
            data={this.state.mostPurchaseSubCategory || []}
            columns={[
              { label: "Sub Category", key: "SubCategory" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingSubCategory}
          />
          </div>
          <div className="col-md-4">
          <DashboardTableWidget
            title="Brand"
            data={this.state.mostPurchaseBrand}
            columns={[
              { label: "Brand", key: "Brand" },
              { label: "Qty", key: "Qty", align: "right" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingBrand}
          />
          </div>

         

          <div className="col-md-4">
          <DashboardTableWidget
            title="Most Purchase Product"
            data={this.state.mostPurchaseProduct}
            columns={[
              { label: "Product", key: "Product" },
              { label: "Qty", key: "Qty" },
              { label: "Amount", key: "Amount", align: "right" }
            ]}
            loading={this.state.loadingMostPurchaseProduct}
          />
          </div>
          <div className="col-md-4">
          <DashboardTableWidget
            title="Top Vendor Purchase"
            data={this.state.topVendorPurchase}
            columns={[
              { label: "Vendor Name", key: "vendorName" },
              { label: "Qty", key: "totalQty" },
              {label:"Total Transactions",key:"totalTransactions"},
              { label: "Purchase", key: "totalPurchase", align: "right" }
            ]}
            loading={this.state.loadingTopVendorPurchase}
          />
          </div>
           <div className="col-md-4">
          <DashboardTableWidget
            title="Top Expense Category"
            data={this.state.topExpenseCategories}
            columns={[
              { label: "Category", key: "ExpenseCategory" },
              { label: "Amount", key: "TotalAmount", align: "right" }
            ]}
            loading={this.state.loadingTopExpenseCategory}
          />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return isMobileApp() ? this.renderMobile() : this.renderDesktop();
  }
}



export default InventoryDashboard;